import { render, staticRenderFns } from "./LotteryAnimation.vue?vue&type=template&id=3897df37&scoped=true"
import script from "./LotteryAnimation.vue?vue&type=script&lang=js"
export * from "./LotteryAnimation.vue?vue&type=script&lang=js"
import style0 from "./LotteryAnimation.vue?vue&type=style&index=0&id=3897df37&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3897df37",
  null
  
)

export default component.exports